export default [
  {
    path: '/data-export',
    name: 'dataexports',
    component: () => import('@/views/DataExport.vue'),
    meta: {
      pageTitle: 'DEBTIA_DATA_EXPORT',
      breadcrumb: [
        {
          text: 'DEBTIA_DATA_EXPORT',
          active: true,
        },
      ],
      action: 'dataexport',
      resource: 'dataexport',
    },
  },
]
